import { render } from "./EmployeeCompanyAsset.vue?vue&type=template&id=2e8b7a71"
import script from "./EmployeeCompanyAsset.vue?vue&type=script&lang=js"
export * from "./EmployeeCompanyAsset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__